import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    // Initialize state to track if an error has occurred
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  // 1. Lifecycle method to update state when an error is thrown
  // This renders a fallback UI after an error has been thrown
  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true, error: error };
  }

  // 2. Lifecycle method to log error information
  // This is where you would send the error to a logging service (e.g., Sentry, LogRocket)
  componentDidCatch(error, errorInfo) {
    // You can also log error messages to an error reporting service here
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    this.setState({ errorInfo: errorInfo });
    // Example: logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI: You can customize this to be a professional-looking page
      return (
        <div style={{ padding: '20px', border: '1px solid red', margin: '20px' }}>
          <h2>Oops! Something went wrong.</h2>
          <p>We're sorry for the inconvenience. Please try reloading the application.</p>
          {/* Display error details for developers, hide this in production */}
          {/*this.props.debug && (
            <details style={{ whiteSpace: 'pre-wrap' }}>
              {this.state.error && this.state.error.toString()}
              <br />
              {this.state.errorInfo.componentStack}
            </details>
          )*/}
        </div>
      );
    }

    // Normally, just render the child components
    return this.props.children;
  }
}

export default ErrorBoundary;